<template>
<div>
  <div>

    <el-tabs type="border-card" v-model="card_index">

      <el-tab-pane label="资料管理" name="DataEditor">
        <DataEditor v-if="card_index==='DataEditor'" />
      </el-tab-pane>
      <el-tab-pane label="装修填报" name="FurnishEditor">
        <FurnishEditor v-if="card_index==='FurnishEditor'" />
      </el-tab-pane>
      <el-tab-pane label="进场准备" name="PreparationEntry">
        <PreparationEntry v-if="card_index==='PreparationEntry'"/>
      </el-tab-pane>
      <el-tab-pane label="装修入场" name="DecorationEntry">
        <DecorationEntry v-if="card_index==='DecorationEntry'" />
      </el-tab-pane>
      <el-tab-pane label="装修巡查" name="DecorationInspection">
        <DecorationInspection v-if="card_index==='DecorationInspection'" />
      </el-tab-pane>
      <el-tab-pane label="装修完工确认" name="DecorationAcceptance">
        <DecorationAcceptance v-if="card_index==='DecorationAcceptance'" />
      </el-tab-pane>
      <el-tab-pane label="押金结算" name="DepositSettlement">
        <DepositSettlement v-if="card_index==='DepositSettlement'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</div>
</template>

<script>
import FurnishEditor from "./FurnishEditor";
import FurnishApply from "./FurnishApply";
import FurnishFilings from "./FurnishFilings";
import FurnishTripleAgreement from "./FurnishTripleAgreement";
import FinishedProductsProtection from "./FinishedProductsProtection";
import FurnishAdmission from "./FurnishAdmission";
import DataEditor from "./DataEditor";
import PreparationEntry from "./PreparationEntry";
import DecorationEntry from "./DecorationEntry";
import DecorationInspection from "./DecorationInspection";
import DecorationAcceptance from "./DecorationAcceptance";
import DepositSettlement from "./DepositSettlement";
export default {
  name: "FurnishMain",
  components: {
    DepositSettlement,
    DecorationAcceptance,
    DecorationInspection,
    DecorationEntry,
    PreparationEntry,
    DataEditor,
    FurnishAdmission,
    FinishedProductsProtection, FurnishTripleAgreement, FurnishFilings, FurnishApply, FurnishEditor},
  inject:['mainObj','componentId','setComponentId'],
  provide(){
    return{
      ProcessState:this.ProcessState,
      setProcessState:this.setProcessState
    }
  },
  data(){
    return{
      card_index:"FurnishEditor",
      ProcessState:0
    }
  },
  methods:{
    setProcessState(ProcessState){
      console.log("setProcessState ->",ProcessState)
      this.ProcessState=ProcessState?(ProcessState*1):0;
    }
  },
  computed:{
    disabled_id(){
      return !this.mainObj.id
    },
    component_id(){
      return this.componentId
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/FurnishMain.vue